import { CharacterCounter } from '@/components/common/CharacterCounter';
import { LabelText } from '@/components/common/LabelText';
import { FormLabel } from '@/components/ui/form';
import { FIELD_LABEL_CLASS } from './formDialog.constants';

interface FormFieldLabelProps {
  label: string;
  isRequired: boolean;
  countedValue?: unknown;
  characterLimit?: number | undefined;
}

export function FormFieldLabel({
  label,
  isRequired,
  countedValue,
  characterLimit,
}: FormFieldLabelProps) {
  const fieldLabel = (
    <FormLabel className={FIELD_LABEL_CLASS}>
      <LabelText isRequired={isRequired}>{label}</LabelText>
    </FormLabel>
  );

  if (characterLimit === undefined) return fieldLabel;

  const currentLength = typeof countedValue === 'string' ? countedValue.length : 0;

  return (
    <div className="flex items-center justify-between gap-2">
      {fieldLabel}
      <CharacterCounter current={currentLength} max={characterLimit} />
    </div>
  );
}
